let storeInstance = null;

export const injectStore = (storeRef) => {
  storeInstance = storeRef;
};

export const getStore = () => storeInstance;
